// extracted by mini-css-extract-plugin
module.exports = {"iconImage":"RoundImg-LTI_iconImage_8QNEu","imageBody":"RoundImg-LTI_imageBody_16nbb","xs":"RoundImg-LTI_xs_3o-uJ"};